import React, { useState, useEffect, useMemo, useCallback } from 'react'; // Importa useRef e useMemo
import { Tab, Tabs, Button, Spinner, Modal, Form, Row, Col, Image, Alert } from 'react-bootstrap'; // Adicionado Row, Col, Image e Alert
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../UserContext';
import config from '../config'; 
import axios from 'axios';
import { useEntidadeContext } from '../EntidadeContext'; // Importar contexto da entidade
import MaterialTab from '../components/estoque/MaterialTab'; // Importar o novo componente
import EstoqueItensTab from '../components/estoque/EstoqueItensTab'; // Importar o novo componente
import { useAlertModal } from '../AlertModalContext';
import logoImage from '../img/logo.png'; // Importa a imagem da logo
import { useAuthContext } from '../context/AuthContext'; // Importar para verificar assinatura


const Estoque = () => {
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext(); // Obter estados do contexto
    const { currentEntidade, isLoadingEntidade } = useEntidadeContext(); // Usar contexto
    const [estoque, setEstoque] = useState([]);  // New state for stock data
    const { showAlertModal } = useAlertModal();

    const { authState } = useAuthContext(); // Obter o estado de autenticação
    const navigate = useNavigate(); // Para o botão de redirecionamento
    // Novos estados para o Modal de Ajuste de Estoque
    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [itemToAdjust, setItemToAdjust] = useState(null);
    const [adjustmentData, setAdjustmentData] = useState({
        quantidade: '',
        tipo_movimento: 'entrada_manual',
        justificativa: ''
    });
    const [isSavingAdjustment, setIsSavingAdjustment] = useState(false);

    // Novos estados para o Modal de Unificação de Materiais
    const [showMergeModal, setShowMergeModal] = useState(false);
    const [mainMaterialId, setMainMaterialId] = useState('');
    const [sourceMaterialId, setSourceMaterialId] = useState('');
    const [isMerging, setIsMerging] = useState(false);
    const [mergeMessage, setMergeMessage] = useState(null);

    // Novos estados para o Modal de Desvinculação (Inativação forçada)
    const [showUnlinkModal, setShowUnlinkModal] = useState(false);
    const [materialToUnlink, setMaterialToUnlink] = useState(null);
    const [isUnlinking, setIsUnlinking] = useState(false);

    // Novo estado para o filtro de materiais ativos/inativos
    const [mostrarInativos, setMostrarInativos] = useState(false);

    const [tiposMateriais, setTiposMateriais] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false); // Mantém para o modal de MaterialTab
    const [novoMaterial, setNovoMaterial] = useState({
      nome: '',
        descricao: '',
        tipo: '', // For tipo material nome
        fornecedor: '',
        lote: '',
        validade: '',
        fabricante: '',
        numero_serie: '',
        quantidade_adquirida: 0,
        valor: 0,
        valor_unidade: 0,
        unidade_medida: '', // For tipo material
        quantidade: 0,  // For estoque inicial
        estoque_minimo: 0,
        estoque_maximo: '',
    }); 

    // Obter abas permitidas para Estoque
    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('estoque', currentUserRole);
      },
      [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig]
    );
    // Define a aba ativa inicial para a primeira permitida, ou 'material' como fallback
    const [key, setKey] = useState(permittedTabs[0]?.key || 'material');

    // Ajusta a aba ativa se a atual não for permitida para a role (useEffect)
    useEffect(() => {
        if (permittedTabs.length > 0 && !isLoadingAccessConfig && !permittedTabs.some(tab => tab.key === key)) { // Garante que o loading terminou
            setKey(permittedTabs[0].key);
        }
    }, [key, permittedTabs, isLoadingAccessConfig]); // Ajustadas dependências

    const fetchData = useCallback(async () => {
        if (!currentEntidade?.id) return;
        setIsLoading(true);
        try {
            const statusFiltro = mostrarInativos ? 'inativo' : 'ativo';
            const [tiposResponse, estoqueResponse] = await Promise.all([
                axios.get(`/api/tipos_materiais?entidade_id=${currentEntidade.id}&status=${statusFiltro}`),
                axios.get(`/api/estoque?entidade_id=${currentEntidade.id}`)
            ]);
            setTiposMateriais(tiposResponse.data.tipos_materiais || []);
            setEstoque(estoqueResponse.data.estoque || []);
        } catch (error) {
            console.error('Erro ao buscar dados do estoque:', error);
        } finally {
            setIsLoading(false);
        }
    }, [currentEntidade, mostrarInativos]);

    
    useEffect(() => {
        // Este efeito agora é acionado sempre que a entidade muda ou o filtro 'mostrarInativos' é alterado (via dependência de fetchData).
        // A verificação garante que só buscamos os dados quando a entidade está carregada.
        if (currentEntidade?.id && !isLoadingEntidade) {
            fetchData();
        }
    }, [currentEntidade, isLoadingEntidade, fetchData]); // fetchData agora inclui a dependência 'mostrarInativos'

    
    // Helper function to find stock quantity for a given tipoMaterial
    const getQuantidadeEmEstoque = (tipoMaterialId) => {
        const estoqueItem = estoque.find(item => item.materiais_tipos_id === tipoMaterialId);
        return estoqueItem ? estoqueItem.quantidade_em_estoque : 0; // Return 0 if not found
    };

    // Filtra a lista de estoque para não mostrar itens que estão inativos E com estoque zerado.
    const estoqueFiltrado = useMemo(() => {
        if (!estoque) {
            return [];
        }
        return estoque.filter(item => {
            // Mantém o item se o tipo de material for ativo, OU se a quantidade em estoque for diferente de zero.
            // Oculta apenas se for inativo E zerado.

            if (item.tipo_material?.ativo == 0 && item.quantidade_em_estoque == 0) {
               return false;
            } else {
                return true;
            }
            
        }).sort((a, b) => {
            const nomeA = a.tipo_material?.nome || '';
            const nomeB = b.tipo_material?.nome || '';
            return nomeA.localeCompare(nomeB);
        });
    }, [estoque]);

    const handleOpenModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        setNovoMaterial({
          nome: '',
          descricao: '',
          tipo: '',
          fornecedor: '',
          lote: '',
          validade: '',
          fabricante: '',
          numero_serie: '',
          quantidade_adquirida: 0,
          valor: '', // Resetting to a number won't work with CurrencyInput. Use '0.00' or similar
          valor_unidade: 0,
          unidade_medida: '',
          quantidade: 0,
          estoque_minimo: 0,
          estoque_maximo: '',


      });
    };

    const handleChange = (event) => {
      const { name, value } = event.target;
      const parsedValue = name === 'valor' || name === 'quantidade_adquirida' || name === 'quantidade'
        ? parseFloat(value) || 0 // Garante que seja um número ou 0 se NaN
        : value;
      setNovoMaterial(prevState => {

          const newState = { ...prevState, [name]: parsedValue };

          if(name === 'valor' || name === 'quantidade_adquirida') { // only recalculate if valor or quantidade_adquirida changes
              if (newState.quantidade_adquirida > 0) {

                newState.valor_unidade = (parseFloat(newState.valor) / parseFloat(newState.quantidade_adquirida)).toFixed(2);
              } else {
                newState.valor_unidade = 0; // Or handle as appropriate (e.g., disable submit, show error message if quantidade_adquirida <= 0 when valor > 0)
              }
          }
          return newState;
      });
    };

    
    const handleSubmit = async (event) => {
      event.preventDefault();
      setIsLoading(true);
      if (!currentEntidade) return; // Segurança

  
      try {
        const data = {
          ...novoMaterial, 
          entidade_id: currentEntidade.id, // Adiciona o entidade_id do contexto
          quantidade_em_estoque: novoMaterial.quantidade_adquirida}; //Include quantidade_adquirida and valor_unidade
        const response = await axios.post(`/api/materiais/criar-com-tipo`, data); //Send to backend

        // // Make a single request to the criar-com-tipo route
        // const response = await axios.post(`/api/materiais/criar-com-tipo`, data);
        // // Handle the response (e.g., update state, display success message)
        // Atualiza a lista de tipos de materiais e estoque após a criação
        const [tiposResponse, estoqueResponse] = await Promise.all([
            axios.get(`/api/tipos_materiais?entidade_id=${currentEntidade.id}`),
            axios.get(`/api/estoque?entidade_id=${currentEntidade.id}`)
        ]);
        setTiposMateriais(tiposResponse.data.tipos_materiais);
        setEstoque(estoqueResponse.data.estoque);

        handleCloseModal();
      } catch (error) {
        console.error('Erro ao criar material e estoque:', error);
        if (error.response && error.response.data && error.response.data.errors) {
            // Exiba mensagens de erro de validação do backend
            console.error(error.response.data.errors); // Log the errors for debugging
    
            // Create an error message string to display to the user
            const errorMessages = Object.values(error.response.data.errors).flat().join('\n');
            alert(errorMessages);
    
        } else {
            alert('Ocorreu um erro ao criar o material e estoque.');
        }
    
      } finally {
        setIsLoading(false);
      }
    };

    // Handlers para o Modal de Ajuste de Estoque
    const handleOpenAdjustModal = (item) => {
        setItemToAdjust(item);
        setShowAdjustModal(true);
    };

    const handleCloseAdjustModal = () => {
        setShowAdjustModal(false);
        setItemToAdjust(null);
        setAdjustmentData({
            quantidade: '',
            tipo_movimento: 'entrada_manual',
            justificativa: ''
        });
    };

    const handleAdjustmentChange = (e) => {
        const { name, value } = e.target;
        setAdjustmentData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveAdjustment = async (e) => {
        e.preventDefault();
        if (!itemToAdjust || !adjustmentData.quantidade) {
            alert('A quantidade é obrigatória.');
            return;
        }

        // Converte a quantidade para um número positivo para garantir consistência.
        let quantidadeAjuste = Math.abs(parseFloat(adjustmentData.quantidade));

        // Se o movimento for de saída ou perda, transforma a quantidade em um número negativo.
        if (adjustmentData.tipo_movimento === 'saida_manual' || adjustmentData.tipo_movimento === 'perda') {
            quantidadeAjuste = -quantidadeAjuste;
        }

        setIsSavingAdjustment(true);
        try {
            const payload = {
                ...adjustmentData,
                entidade_id: currentEntidade.id,
                estoque_id: itemToAdjust.id,
                quantidade: quantidadeAjuste // Usa a quantidade ajustada (positiva ou negativa)
            };

            // O backend já está preparado para receber um valor positivo ou negativo.
            const response = await axios.post('/api/estoque/ajustar', payload);

            // Atualiza o estado local com o novo dado do estoque
            const updatedEstoqueItem = response.data.estoque;
            setEstoque(prevEstoque =>
                prevEstoque.map(item =>
                    item.id === updatedEstoqueItem.id ? updatedEstoqueItem : item
                )
            );
            handleCloseAdjustModal();
        } catch (error) {
            console.error("Erro ao ajustar estoque:", error);
            alert(`Erro ao ajustar estoque: ${error.response?.data?.message || 'Tente novamente.'}`);
        } finally {
            setIsSavingAdjustment(false);
        }
    };

    const handleMinimoChange = async (itemId, novoMinimo) => {
        const item = estoque.find(i => i.id === itemId);
        const novoMinimoNumerico = Number(novoMinimo);

        // Previne chamada de API se o valor não mudou ou é inválido
        if (!item || Number(item.estoque_minimo) === novoMinimoNumerico || isNaN(novoMinimoNumerico)) {
            return;
        }

        try {
            // Este endpoint precisa ser criado no backend (PATCH é ideal para atualizações parciais)
            const response = await axios.patch(`/api/estoque/${itemId}`, {
                estoque_minimo: novoMinimoNumerico
            });

            // Atualiza o estado local com o novo dado do estoque
            const updatedEstoqueItem = response.data.estoque;
            setEstoque(prevEstoque => prevEstoque.map(item => item.id === updatedEstoqueItem.id ? updatedEstoqueItem : item));
        } catch (error) {
            console.error("Erro ao atualizar estoque mínimo:", error);
            alert(`Erro ao atualizar estoque mínimo: ${error.response?.data?.message || 'Tente novamente.'}`);
            // Opcional: reverter a mudança na UI ou buscar os dados novamente para garantir consistência.
        }
    };

    const handleToggleStatus = async (tipoMaterialId) => {
        const action = mostrarInativos ? 'reativar' : 'inativar';
        const title = `Confirmar ${mostrarInativos ? 'Reativação' : 'Inativação'}`;
        const message = `Tem certeza que deseja ${action} este tipo de material?`;

        showAlertModal(
            title,
            message,
            'warning',
            async () => {
                setIsLoading(true);
                try {
                    await axios.patch(`/api/tipos_materiais/${tipoMaterialId}/toggle-status`);
                    const successMessage = `Material ${action === 'inativar' ? 'inativado' : 'reativado'} com sucesso.`;
                    showAlertModal('Sucesso', successMessage, 'success');
                    await fetchData(); // Recarrega a lista para refletir a mudança
                } catch (error) {
                    // Verifica se é erro de conflito (serviços vinculados) ao tentar inativar
                    if (action === 'inativar' && error.response && error.response.status === 409) {
                        const material = tiposMateriais.find(t => t.id === tipoMaterialId);
                        const servicosVinculados = error.response.data.servicos || [];
                        setMaterialToUnlink({ 
                            ...(material || { id: tipoMaterialId, nome: 'Material' }), 
                            servicosVinculados 
                        });
                        setShowUnlinkModal(true);
                    } else {
                        showAlertModal(
                            'Erro',
                            error.response?.data?.message || 'Não foi possível alterar o status do material.',
                            'danger'
                        );
                    }
                } finally {
                    setIsLoading(false);
                }
            },
            true // isConfirmation
        );
    };

    const handleCloseUnlinkModal = () => {
        setShowUnlinkModal(false);
        setMaterialToUnlink(null);
    };

    const handleConfirmUnlink = async () => {
        if (!materialToUnlink) return;
        setIsUnlinking(true);
        try {
            // Envia force_unlink: true para forçar a desvinculação e inativação
            await axios.patch(`/api/tipos_materiais/${materialToUnlink.id}/toggle-status`, { force_unlink: true });
            showAlertModal('Sucesso', 'Material desvinculado dos serviços e inativado com sucesso!', 'success');
            fetchData();
            handleCloseUnlinkModal();
        } catch (error) {
            showAlertModal('Erro', error.response?.data?.message || 'Erro ao inativar material.', 'danger');
        } finally {
            setIsUnlinking(false);
        }
    };

    // Handlers para o Modal de Unificação
    const handleOpenMergeModal = () => {
        setMergeMessage(null);
        setMainMaterialId('');
        setSourceMaterialId('');
        setShowMergeModal(true);
    };

    const handleCloseMergeModal = () => setShowMergeModal(false);

    const handleMergeSubmit = async () => {
        if (!mainMaterialId || !sourceMaterialId) {
            setMergeMessage({ type: 'danger', text: 'Por favor, selecione ambos os materiais.' });
            return;
        }
        if (mainMaterialId === sourceMaterialId) {
            setMergeMessage({ type: 'danger', text: 'Os materiais devem ser diferentes.' });
            return;
        }

        setIsMerging(true);
        setMergeMessage(null);

        try {
            await axios.post('/api/tipos_materiais/merge', {
                entidade_id: currentEntidade.id,
                main_tipo_id: mainMaterialId,
                source_tipo_id: sourceMaterialId,
            });
            setMergeMessage({ type: 'success', text: 'Materiais unificados com sucesso! A lista será atualizada.' });
            
            // Aguarda a atualização dos dados e depois fecha o modal
            await fetchData();
            setTimeout(() => handleCloseMergeModal(), 2000);

        } catch (error) {
            setMergeMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao unificar materiais.' });
        } finally {
            setIsMerging(false);
        }
    };

    // --- INÍCIO DA VALIDAÇÃO DE ACESSO AO CONTEÚDO ---
    const isAccessBlocked = useMemo(() => {
        const subscription = authState.subscription;

        // Se a assinatura existe, não é vitalícia e não está ativa/em teste
        if (subscription && !subscription.plan?.is_lifetime ) {
            const expirationDate = new Date(subscription.current_period_ends_at + 'T00:00:00');
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (today > expirationDate) {
                const diffTime = today.getTime() - expirationDate.getTime();
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                // Bloqueia o acesso se expirou há mais de 10 dias
                if (diffDays > 10) {
                    return true;
                }
            }
        }
        // Se nenhuma condição de bloqueio for atendida, permite o acesso.
        return false;
    }, [authState.subscription]);

    const BlockedContent = () => (
        <Alert variant="danger" className="text-center m-4">
            <Alert.Heading>Acesso ao Estoque Restrito</Alert.Heading>
            <p>Seu plano expirou há mais de 10 dias. Para gerenciar seu estoque, por favor, regularize sua assinatura.</p>
            <Button variant="danger" onClick={() => navigate('/pricing')}>Ver Planos e Regularizar</Button>
        </Alert>
    );

    return (
        <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                @keyframes dropdownFadeIn {
                    from { opacity: 0; transform: translateY(-4px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
            `}</style>

            {/* ── CABEÇALHO ── */}
            <div style={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                padding: '20px 28px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img src={logoImage} alt="Logo" style={{ height: '44px', width: 'auto', opacity: 0.9 }} />
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#fff' }}>
                            Gestão de Estoque
                        </h2>
                        <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: 'rgba(255,255,255,0.7)' }}>
                            {currentEntidade?.nome || 'Clínica'}
                        </p>
                    </div>
                </div>
                <div style={{
                    padding: '4px 12px', borderRadius: '999px',
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#fff',
                    border: '1px solid rgba(255,255,255,0.25)',
                }}>
                    {currentUserRole}
                </div>
            </div>

            {/* ── CORPO ── */}
            <div style={{ padding: '24px 28px' }}>
                {isAccessBlocked ? (
                    /* ── ACESSO BLOQUEADO ── */
                    <div style={{
                        textAlign: 'center', padding: '60px 24px',
                        backgroundColor: '#fff', borderRadius: '16px',
                        border: '1px solid #fecaca', boxShadow: '0 4px 20px rgba(239,68,68,0.1)',
                        maxWidth: '480px', margin: '0 auto',
                    }}>
                        <div style={{
                            width: '64px', height: '64px', borderRadius: '50%',
                            backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 16px',
                        }}>
                            <svg width="28" height="28" fill="none" stroke="#ef4444" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </div>
                        <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '8px' }}>
                            Acesso ao Estoque Restrito
                        </h3>
                        <p style={{ fontSize: `calc(14px * var(--font-scale))`, color: '#6b7280', marginBottom: '24px', lineHeight: '1.6' }}>
                            Seu plano expirou há mais de 10 dias. Para gerenciar seu estoque, por favor, regularize sua assinatura.
                        </p>
                        <button
                            onClick={() => navigate('/pricing')}
                            style={{
                                padding: '10px 24px', borderRadius: '8px', border: 'none',
                                background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                                color: '#fff', fontSize: `calc(14px * var(--font-scale))`, fontWeight: '600',
                                cursor: 'pointer', fontFamily: 'inherit',
                            }}
                        >
                            Ver Planos e Regularizar
                        </button>
                    </div>
                ) : (
                    /* ── ABAS ── */
                    <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e5e7eb', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                        {/* Header das abas */}
                        <div style={{ borderBottom: '1px solid #e5e7eb', display: 'flex', padding: '0 20px', backgroundColor: '#fff' }}>
                            {getPermittedInternalTabs('estoque', currentUserRole).map(tab => (
                                <button
                                    key={tab.key}
                                    onClick={() => setKey(tab.key)}
                                    style={{
                                        padding: '14px 20px', border: 'none', background: 'none',
                                        fontSize: `calc(13px * var(--font-scale))`, fontWeight: key === tab.key ? '600' : '500',
                                        color: key === tab.key ? '#2563eb' : '#6b7280',
                                        borderBottom: key === tab.key ? '2px solid #2563eb' : '2px solid transparent',
                                        marginBottom: '-1px', cursor: 'pointer',
                                        transition: 'all 0.15s', fontFamily: 'inherit',
                                        whiteSpace: 'nowrap',
                                    }}
                                    onMouseEnter={e => { if (key !== tab.key) e.currentTarget.style.color = '#374151'; }}
                                    onMouseLeave={e => { if (key !== tab.key) e.currentTarget.style.color = '#6b7280'; }}
                                >
                                    {tab.title}
                                </button>
                            ))}
                        </div>

                        {/* Conteúdo das abas */}
                        <div style={{ padding: '24px' }}>
                            {getPermittedInternalTabs('estoque', currentUserRole).map(tab => (
                                key === tab.key && (
                                    <div key={tab.key}>
                                        {tab.key === 'material' && (
                                            <MaterialTab
                                                tiposMateriais={tiposMateriais}
                                                isLoading={isLoading}
                                                showModal={showModal}
                                                handleCloseModal={handleCloseModal}
                                                handleOpenModal={handleOpenModal}
                                                handleOpenMergeModal={handleOpenMergeModal}
                                                mostrarInativos={mostrarInativos}
                                                setMostrarInativos={setMostrarInativos}
                                                handleToggleStatus={handleToggleStatus}
                                                novoMaterial={novoMaterial}
                                                handleChange={handleChange}
                                                handleSubmit={handleSubmit}
                                                getQuantidadeEmEstoque={getQuantidadeEmEstoque}
                                            />
                                        )}
                                        {tab.key === 'estoque' && (
                                            <EstoqueItensTab
                                                estoque={estoqueFiltrado}
                                                handleOpenAdjustModal={handleOpenAdjustModal}
                                                handleMinimoChange={handleMinimoChange}
                                            />
                                        )}
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* ══════════════════════════════════════════════════════════
                MODAL: AJUSTE DE ESTOQUE
            ══════════════════════════════════════════════════════════ */}
            <Modal show={showAdjustModal} onHide={handleCloseAdjustModal} centered>
                <Modal.Header style={{ padding: '0', border: 'none' }}>
                    <div style={{
                        width: '100%', padding: '20px 24px',
                        background: 'linear-gradient(135deg, #92400e, #d97706)',
                        display: 'flex', alignItems: 'center', gap: '12px',
                    }}>
                        <div style={{
                        width: '40px', height: '40px', borderRadius: '10px',
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        }}>
                        <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                        </svg>
                        </div>
                        <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff', flex: 1 }}>
                        Unificar Tipos de Materiais
                        </div>
                        {/* Botão fechar customizado */}
                        <button
                        onClick={handleCloseMergeModal}
                        style={{
                            width: '28px', height: '28px', borderRadius: '6px',
                            border: '1px solid rgba(255,255,255,0.3)',
                            backgroundColor: 'rgba(255,255,255,0.15)',
                            color: '#fff', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '16px', lineHeight: 1, flexShrink: 0,
                            transition: 'background 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
                        >
                        ×
                        </button>
                    </div>
                    </Modal.Header>
                <Modal.Body style={{ padding: '24px', backgroundColor: '#f9fafb' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {/* Tipo de Movimento */}
                        <div>
                            <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                Tipo de Movimento
                            </label>
                            <select
                                name="tipo_movimento"
                                value={adjustmentData.tipo_movimento}
                                onChange={handleAdjustmentChange}
                                style={{
                                    width: '100%', padding: '9px 12px', borderRadius: '8px',
                                    border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                                    fontFamily: 'inherit', backgroundColor: '#fff', outline: 'none',
                                }}
                            >
                                <option value="entrada_manual">Entrada (Manual)</option>
                                <option value="saida_manual">Saída (Manual)</option>
                                <option value="perda">Perda</option>
                                <option value="ajuste_contagem">Ajuste (Contagem)</option>
                            </select>
                        </div>

                        {/* Quantidade */}
                        <div>
                            <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                Quantidade *
                            </label>
                            <input
                                type="number"
                                name="quantidade"
                                value={adjustmentData.quantidade}
                                onChange={handleAdjustmentChange}
                                min="0"
                                placeholder="Ex: 10"
                                style={{
                                    width: '100%', padding: '9px 12px', borderRadius: '8px',
                                    border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                                    fontFamily: 'inherit', outline: 'none',
                                }}
                                onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                                onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
                            />
                            <p style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af', marginTop: '4px', marginBottom: 0 }}>
                                A quantidade será somada (Entrada/Ajuste) ou subtraída (Saída/Perda) do estoque.
                            </p>
                        </div>

                        {/* Justificativa */}
                        <div>
                            <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                Justificativa
                            </label>
                            <textarea
                                name="justificativa"
                                value={adjustmentData.justificativa}
                                onChange={handleAdjustmentChange}
                                rows={3}
                                placeholder="Ex: Compra de novo lote, quebra de material, etc."
                                style={{
                                    width: '100%', padding: '9px 12px', borderRadius: '8px',
                                    border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                                    fontFamily: 'inherit', resize: 'vertical', outline: 'none',
                                }}
                                onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                                onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px', backgroundColor: '#fff' }}>
                    <button
                        onClick={handleCloseAdjustModal}
                        disabled={isSavingAdjustment}
                        style={{
                            padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
                            backgroundColor: '#fff', color: '#374151', cursor: isSavingAdjustment ? 'not-allowed' : 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit',
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSaveAdjustment}
                        disabled={isSavingAdjustment}
                        style={{
                            padding: '8px 20px', borderRadius: '8px', border: 'none',
                            background: isSavingAdjustment ? '#93c5fd' : 'linear-gradient(135deg, #1e3a5f, #2563eb)',
                            color: '#fff', cursor: isSavingAdjustment ? 'not-allowed' : 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
                            display: 'flex', alignItems: 'center', gap: '8px',
                        }}
                    >
                        {isSavingAdjustment && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                        {isSavingAdjustment ? 'Salvando...' : 'Salvar Ajuste'}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* ══════════════════════════════════════════════════════════
                MODAL: UNIFICAÇÃO DE MATERIAIS
            ══════════════════════════════════════════════════════════ */}
            <Modal show={showMergeModal} onHide={handleCloseMergeModal} centered>
                <Modal.Header closeButton style={{ padding: '0', border: 'none' }}>
                    <div style={{
                        width: '100%', padding: '20px 24px',
                        background: 'linear-gradient(135deg, #92400e, #d97706)',
                        display: 'flex', alignItems: 'center', gap: '12px',
                    }}>
                        <div style={{
                            width: '40px', height: '40px', borderRadius: '10px',
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        }}>
                            <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                            </svg>
                        </div>
                        <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>
                            Unificar Tipos de Materiais
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: '24px', backgroundColor: '#f9fafb' }}>
                    {/* Mensagem de feedback */}
                    {mergeMessage && (
                        <div style={{
                            padding: '12px 16px', borderRadius: '8px', marginBottom: '16px',
                            backgroundColor: mergeMessage.type === 'success' ? '#f0fdf4' : '#fef2f2',
                            border: `1px solid ${mergeMessage.type === 'success' ? '#bbf7d0' : '#fecaca'}`,
                            color: mergeMessage.type === 'success' ? '#16a34a' : '#dc2626',
                            fontSize: `calc(13px * var(--font-scale))`, display: 'flex', alignItems: 'center', gap: '8px',
                        }}>
                            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {mergeMessage.type === 'success'
                                    ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                }
                            </svg>
                            {mergeMessage.text}
                        </div>
                    )}

                    {/* Aviso */}
                    <div style={{
                        padding: '12px 14px', borderRadius: '8px', marginBottom: '20px',
                        backgroundColor: '#fffbeb', border: '1px solid #fde68a',
                        display: 'flex', gap: '10px', alignItems: 'flex-start',
                    }}>
                        <svg width="16" height="16" fill="none" stroke="#f59e0b" viewBox="0 0 24 24" style={{ flexShrink: 0, marginTop: '1px' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: '#92400e', lineHeight: '1.5' }}>
                            Esta ação irá transferir todos os lotes e o estoque de um material para outro, e depois excluirá o material de origem. <strong>Esta ação não pode ser desfeita.</strong>
                        </p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {/* Material Principal */}
                        <div>
                            <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                Material Principal (Manter)
                            </label>
                            <select
                                value={mainMaterialId}
                                onChange={(e) => setMainMaterialId(e.target.value)}
                                style={{
                                    width: '100%', padding: '9px 12px', borderRadius: '8px',
                                    border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                                    fontFamily: 'inherit', backgroundColor: '#fff', outline: 'none',
                                }}
                            >
                                <option value="">Selecione o material que permanecerá...</option>
                                {tiposMateriais.map(tipo => (
                                    <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                                ))}
                            </select>
                        </div>

                        {/* Ícone de seta */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{
                                width: '32px', height: '32px', borderRadius: '50%',
                                backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <svg width="14" height="14" fill="none" stroke="#9ca3af" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                </svg>
                            </div>
                        </div>

                        {/* Material a ser Absorvido */}
                        <div>
                            <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                Material a ser Unificado (Excluir)
                            </label>
                            <select
                                value={sourceMaterialId}
                                onChange={(e) => setSourceMaterialId(e.target.value)}
                                disabled={!mainMaterialId}
                                style={{
                                    width: '100%', padding: '9px 12px', borderRadius: '8px',
                                    border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                                    fontFamily: 'inherit', backgroundColor: !mainMaterialId ? '#f9fafb' : '#fff',
                                    outline: 'none', opacity: !mainMaterialId ? 0.6 : 1,
                                }}
                            >
                                <option value="">Selecione o material a ser absorvido...</option>
                                {tiposMateriais
                                    .filter(tipo => tipo.id !== parseInt(mainMaterialId))
                                    .map(tipo => (
                                        <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px', backgroundColor: '#fff' }}>
                    <button
                        onClick={handleCloseMergeModal}
                        disabled={isMerging}
                        style={{
                            padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
                            backgroundColor: '#fff', color: '#374151', cursor: isMerging ? 'not-allowed' : 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit',
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleMergeSubmit}
                        disabled={isMerging || !mainMaterialId || !sourceMaterialId}
                        style={{
                            padding: '8px 20px', borderRadius: '8px', border: 'none',
                            background: (isMerging || !mainMaterialId || !sourceMaterialId)
                                ? '#d1d5db'
                                : 'linear-gradient(135deg, #92400e, #d97706)',
                            color: '#fff',
                            cursor: (isMerging || !mainMaterialId || !sourceMaterialId) ? 'not-allowed' : 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
                            display: 'flex', alignItems: 'center', gap: '8px',
                        }}
                    >
                        {isMerging && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                        {isMerging ? 'Unificando...' : 'Confirmar Unificação'}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* ══════════════════════════════════════════════════════════
                MODAL: DESVINCULAÇÃO E INATIVAÇÃO
            ══════════════════════════════════════════════════════════ */}
            <Modal show={showUnlinkModal} onHide={handleCloseUnlinkModal} centered>
                <Modal.Header closeButton style={{ padding: '0', border: 'none' }}>
                    <div style={{
                        width: '100%', padding: '20px 24px',
                        background: 'linear-gradient(135deg, #7f1d1d, #dc2626)',
                        display: 'flex', alignItems: 'center', gap: '12px',
                    }}>
                        <div style={{
                            width: '40px', height: '40px', borderRadius: '10px',
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        }}>
                            <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>
                            Atenção: Serviços Vinculados
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ padding: '24px', backgroundColor: '#f9fafb' }}>
                    <p style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#374151', marginBottom: '12px' }}>
                        O material <strong>{materialToUnlink?.nome}</strong> está vinculado aos seguintes serviços ativos:
                    </p>

                    {materialToUnlink?.servicosVinculados && materialToUnlink.servicosVinculados.length > 0 ? (
                        <div style={{
                            backgroundColor: '#fff', borderRadius: '10px',
                            border: '1px solid #e5e7eb', overflow: 'hidden', marginBottom: '16px',
                        }}>
                            {materialToUnlink.servicosVinculados.map((servico, index, arr) => (
                                <div key={index} style={{
                                    padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, color: '#374151',
                                    borderBottom: index < arr.length - 1 ? '1px solid #f3f4f6' : 'none',
                                    display: 'flex', alignItems: 'center', gap: '8px',
                                }}>
                                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#3b82f6', flexShrink: 0 }} />
                                    {servico.nome || servico}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#9ca3af', fontStyle: 'italic', marginBottom: '16px' }}>
                            (Lista de serviços não disponível)
                        </p>
                    )}

                    <p style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#374151', marginBottom: '12px' }}>
                        Deseja remover este material desses serviços e inativá-lo?
                    </p>

                    <div style={{
                        padding: '12px 14px', borderRadius: '8px',
                        backgroundColor: '#fffbeb', border: '1px solid #fde68a',
                        display: 'flex', gap: '10px', alignItems: 'flex-start',
                    }}>
                        <svg width="16" height="16" fill="none" stroke="#f59e0b" viewBox="0 0 24 24" style={{ flexShrink: 0, marginTop: '1px' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: '#92400e', lineHeight: '1.5' }}>
                            Esta ação removerá o material da composição de custos dos serviços afetados.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px', backgroundColor: '#fff' }}>
                    <button
                        onClick={handleCloseUnlinkModal}
                        disabled={isUnlinking}
                        style={{
                            padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
                            backgroundColor: '#fff', color: '#374151', cursor: isUnlinking ? 'not-allowed' : 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit',
                        }}
                    >
                        Não
                    </button>
                    <button
                        onClick={handleConfirmUnlink}
                        disabled={isUnlinking}
                        style={{
                            padding: '8px 20px', borderRadius: '8px', border: 'none',
                            background: isUnlinking ? '#fca5a5' : 'linear-gradient(135deg, #dc2626, #b91c1c)',
                            color: '#fff', cursor: isUnlinking ? 'not-allowed' : 'pointer',
                            fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit',
                            display: 'flex', alignItems: 'center', gap: '8px',
                        }}
                    >
                        {isUnlinking && <Spinner as="span" animation="border" size="sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />}
                        {isUnlinking ? 'Processando...' : 'Sim, Desvincular e Inativar'}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );


};

export default Estoque;
